import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getOpenModal, setOpenModal } from 'redux/reducers/header'

export interface TriggerProps {
  onClick?: () => void;
  active?: boolean;
  innerRef?: any;
  label: string;
}

export interface DropdownTriggerProps {
  onClick?: (event?: any) => void;
  children: React.ReactElement<TriggerProps>;
  dropdown: React.ReactNode;
}

export const DropdownTrigger: React.FC<DropdownTriggerProps> = ({
  onClick = (active: string) => {},
  children,
  dropdown
}) => {
  const dropdownRef = useRef(null)
  const triggerRef = useRef(null)

  const dispatch = useDispatch()
  const openModal = useSelector(getOpenModal)

  const handleOnClick = () => {
    dispatch(setOpenModal(children.props.label))
    onClick(children.props.label)
  }

  useEffect(() => {
    const pageClickEvent = (e: Event) => {
      if (dropdownRef.current !== null && dropdownRef.current) {
        // @ts-ignore
        if (!dropdownRef.current.contains(e.target)) {
          dispatch(setOpenModal(''))
        }
      }
    }

    const keyPressEvent = (e: any) => {
      if (e.key === 'Escape') {
        dispatch(setOpenModal(''))
        // @ts-ignore
        if (triggerRef.current) triggerRef.current.focus()
      }
    }

    if (openModal === children.props.label) {
      window.addEventListener('click', pageClickEvent)
      window.addEventListener('keydown', keyPressEvent)
    } else {
      window.removeEventListener('click', pageClickEvent)
      window.removeEventListener('keydown', keyPressEvent)
    }

    return () => {
      window.removeEventListener('click', pageClickEvent)
      window.removeEventListener('keydown', keyPressEvent)
    }
  }, [openModal, children.props.label, dispatch, triggerRef, dropdownRef])

  return (
    <div className='ch-c-dropdown-trigger ch-u-position--relative ds-u-display--inline-block'>
      {React.cloneElement(children, {
        onClick: handleOnClick,
        innerRef: triggerRef
      })}
      {openModal === children.props.label
        ? (
        <>
          <div className='ch-c-up-arrow' />
          <div className='ch-c-dropdown-menu__container' ref={dropdownRef}>
            {dropdown}
          </div>
        </>
          )
        : null}
    </div>
  )
}
